module.exports = __webpack_public_path__ + "img/P47-zh.8a3ead42.png";